module.exports = __webpack_public_path__ + "static/media/medicare.da1778b7.webp";